<template>
  <div>
    <v-container>
      <v-layout row>
        <v-flex xs6>
          <v-btn @click="back" text class="text_btn">
            <v-icon>keyboard_arrow_left</v-icon>back
          </v-btn>
        </v-flex>
        <v-flex xs6 style="text-align:right;"></v-flex>
      </v-layout>
      <h1>
        <v-icon style="padding-bottom:5px;">poll</v-icon>
        Data explorer ({{ p_name }} / {{ b_name }})
      </h1>
      <v-row>
        <v-col cols="12" md="4" class="px-2">
          <div style="margin-top:10px;">
            <v-card class="mb-3" outlined>
              <v-card-text class="py-2">
                <div class="font-weight-bold mb-2" style="font-size: 16px;">Credentials</div>
                <v-row dense>
                  <v-col cols="12" sm="6"><v-text-field label="App ID" v-model="app_id" dense hide-details="auto" /></v-col>
                  <v-col cols="12" sm="6"><v-text-field label="App Secret" v-model="app_secret" dense hide-details="auto" /></v-col>
                  <v-col cols="12"><v-text-field label="Auth token (optional)" v-model="auth_token" dense hide-details="auto" /></v-col>
                </v-row>
                <div class="mt-3 d-flex flex-wrap" style="gap: 8px;">
                  <v-btn small @click="getLastAppIdAndSecret"><i class="fal fa-file-import" style="margin-right:5px;"></i> App creds</v-btn>
                  <v-btn small @click="d_login = true"><i class="fal fa-user" style="margin-right:5px;"></i> Login User</v-btn>
                  <v-btn small color="blue" dark @click="connect"><v-icon small left>save</v-icon>Save</v-btn>
                </div>
              </v-card-text>
            </v-card>

            <v-card class="mb-3" outlined>
              <v-card-text class="py-2">
                <div class="font-weight-bold mb-2" style="font-size: 16px;">Container and dataset</div>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-select v-model="container" :items="available_containers" label="Container" item-text="name" item-value="id" dense hide-details="auto" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field label="Dataset" @keydown="enterLoad" :autocomplete="true" v-model="dataset" dense hide-details="auto" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card class="mb-3" outlined>
              <v-card-text class="py-2">
                <div class="font-weight-bold mb-2" style="font-size: 16px;">Filters</div>
                <FilterContainer ref="filter_container" @newfilters="updateFilters" :columns="columns" />
              </v-card-text>
            </v-card>

            <v-card class="mb-3" outlined>
              <v-card-text class="py-2">
                <div class="font-weight-bold mb-2" style="font-size: 16px;">Options</div>
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-text-field label="Start" v-model="start" type="number" dense hide-details="auto" />
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field label="Limit" v-model="limit" type="number" dense hide-details="auto" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
          <v-btn block @click="load" :loading="l_load" color="blue" dark class="mt-2 mb-4" style="height: 44px; font-size: 16px;">
            <v-icon left>search</v-icon> Query Results
          </v-btn>
        </v-col>
        <v-col cols="12" md="8">
          <div class="result" v-if="columns.length > 0">
            <v-data-table :headers="header" @click:row="editRow" :items="data_datatable" class="clickableTable">
              <template slot="no-data">
                <div>
                  No data available in container
                  <i>{{ container == "" ? "Not set" : container.split('|')[1] }}</i> and dataset
                  <i>{{ dataset }}</i>
                </div>
              </template>
              <template v-slot:item.id="{ item }">
                <i>{{ item.id }}</i>
              </template>
            </v-data-table>
            <div style="margin-top:20px;float:right;">
              <v-btn @click="exportData" style="margin-right:10px;">
                <i class="fal fa-file-csv" style="margin-right:5px;"></i>Export CSV</v-btn>
              <v-btn @click="addDataPrepare">
                <i class="fal fa-plus" style="margin-right:5px;"></i>add row
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- Add data dialog -->
    <v-dialog v-model="d_add_data" width="500">
      <v-card>
        <v-form @submit="add_data">
          <v-card-title class="headline" primary-title>
            Add data in&nbsp;
            <b>{{ container.split("|")[1] }}</b>
          </v-card-title>

          <v-card-text>
            <p>
              Adds a new row with data in the container
              <i>{{ container.split("|")[1] }}</i> with the dataset
              <i>{{ dataset }}</i>.
            </p>
            <v-text-field
              v-model="add_data[column]"
              :label="column"
              v-for="column in columns"
              @keydown="enterAddData"
              :key="column"
            />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text class="text_btn" type="button" @click="addData" :loading="l_add" style="margin-top:20px;">
              <i class="fal fa-save" style="margin-right:5px;"></i>
              Add
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Edit data dialog -->
    <v-dialog v-model="d_edit_data" width="500">
      <v-card>
        <v-form @submit="edit_data">
          <v-card-title class="headline" primary-title>
            Edit data in&nbsp;
            <b>{{ container.split("|")[1] }}</b>
          </v-card-title>

          <v-card-text>
            <p>
              Edits the selected row <i>{{ edit_data["id"] }}</i> in the container <i>{{ container.split("|")[1] }}</i> with dataset <i>{{ dataset }}</i>.
            </p>
            <v-text-field
              v-model="edit_data[column]"
              :label="column"
              v-for="column in columns"
              @keydown="enterEditData"
              :key="column"
            />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="error" text class="text_btn" type="button" @click="deleteData">
              <i class="fal fa-trash" style="margin-right:5px;"></i>
              Delete
            </v-btn>
            <v-btn color="primary" text class="text_btn" type="button" @click="duplicateData">
              <i class="fal fa-copy" style="margin-right:5px;"></i>
              Duplicate
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="default" text class="text_btn" type="button" @click="d_edit_data = false">Cancel</v-btn>
            <v-btn color="primary" text class="text_btn" type="button" @click="editData" :loading="l_edit">
              <i class="fal fa-save" style="margin-right:5px;"></i>
              Edit
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Delete data dialog -->
    <v-dialog v-model="d_delete_data" width="500">
      <v-card>
        <v-form @submit="edit_data">
          <v-card-title class="headline" primary-title>
            Delete data in&nbsp;
            <b>{{ container.split("|")[1] }}</b>
          </v-card-title>

          <v-card-text>
            <p>Are you sure, that you want to delete the complete row {{ delete_data.id }}.</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" text class="text_btn" type="button" @click="d_delete_data = false">Cancel</v-btn>
            <v-btn color="error" text class="text_btn" type="button" @click="deleteDataConfirm" :loading="l_delete">Delete</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Login User Dialog -->
    <v-dialog v-model="d_login" width="500">
      <v-card>
        <v-form @submit.prevent="loginUser">
          <v-card-title class="headline" primary-title>
            Login User
          </v-card-title>

          <v-card-text>
            <p>Authenticate as a user to fetch the authentication token.</p>
            <v-text-field v-model="login_data.email" label="Email" type="email" required />
            <v-text-field v-model="login_data.password" label="Password" type="password" required />
            <v-text-field v-model="login_data.otp" label="OTP Code (if activated)" type="number" />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="default" text class="text_btn" type="button" @click="d_login = false">Cancel</v-btn>
            <v-btn color="primary" text class="text_btn" type="submit" :loading="l_login">Login</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import * as Vars from "../logic/Vars";
import { Columns } from "../logic/Columns";
import { Containers } from "../logic/Containers";
import { Buckets } from "../logic/Buckets";
import { Projects } from "../logic/Projects";

import { Notifications } from "../notification";
import { sCStorage } from "schmucklicloud_storage";
import { Apps } from '../logic/Apps';

import FilterContainer from "../components/dataexplorer/FilterContainer";

export default {
  name: "DataExplorer",
  data() {
    return {
      storage: undefined,

      project_id: 0,

      app_id: "",
      app_secret: "",
      auth_token: "",

      container: "",
      dataset: "",

      filters: [],
      start: "",
      limit: "",

      available_containers: [],

      // Data
      columns: [],
      data: [],

      add_data: {},
      edit_data: {},
      delete_data: {},

      login_data: {
        email: "",
        password: "",
        otp: ""
      },

      p_name: "...",
      b_name: "...",

      // Loaders
      l_load: false,
      l_add: false,
      l_edit: false,
      l_delete: false,
      l_login: false,

      // Dialogs
      d_add_data: false,
      d_edit_data: false,
      d_delete_data: false,
      d_login: false
    };
  },
  computed: {
    header() {
      var header = [{ text: "ID", value: "id" }];
      this.columns.forEach(function(column) {
        header.push({ text: column, value: column });
      });
      return header;
    },
    data_datatable() {
      var data = [];
      this.data.forEach(function(row) {
        row.data["id"] = row.id;
        data.push(row.data);
      });
      return data;
    }
  },
  watch: {
    container: async function(new_val) {
      if (this.$refs.filter_container) {
        this.$refs.filter_container.clearFilters();
      }
      
      if (new_val && new_val !== "") {
        var columns = await Columns.load(new_val.split("|")[0]);
        var fetched_columns = [];
        if (columns.body) {
          columns.body.forEach(
            function(column) {
              fetched_columns.push(column.name);
            }
          );
          this.columns = fetched_columns;
        } else {
          Notifications.show(columns.response);
        }
      } else {
        this.columns = [];
      }
    }
  },
  async mounted() {
    var bucket = this.$route.params.id;
    this.app_id = window.localStorage.getItem(
      "data_explorer__" + bucket + "__app_id",
      this.app_id
    );
    this.app_secret = window.localStorage.getItem(
      "data_explorer__" + bucket + "__app_secret",
      this.app_secret
    );
    this.auth_token = window.sessionStorage.getItem(
      "data_explorer__" + bucket + "__auth_token"
    ) || "";

    this.initialize();

    //Load metadata of bucket
    this.project_id = parseInt(this.$route.params.project_id);

    var bucket_response = await Buckets.get(this.project_id, bucket);
    if (bucket_response.status === 200) this.b_name = bucket_response.body.name;

    var project_response = await Projects.get(this.project_id);
    if (project_response.status === 200) {
      if (Array.isArray(project_response.body) && project_response.body.length > 0) {
        this.p_name = project_response.body[0].name;
      } else if (project_response.body && project_response.body.name) {
        this.p_name = project_response.body.name;
      }
    }

    this.loadContainers();
  },
  methods: {
    initialize() {
      this.storage = new sCStorage(this.app_id, this.app_secret, Vars.API_ENDPOINT + "/client_api/v1/data/");
      if (this.auth_token && this.auth_token !== "") {
        this.storage.setAuthToken(this.auth_token, true);
      }
    },
    connect() {
      var bucket = this.$route.params.id;

      //Save the app id and secret locally for future uses.
      window.localStorage.setItem(
        "data_explorer__" + bucket + "__app_id",
        this.app_id || ""
      );
      window.localStorage.setItem(
        "data_explorer__" + bucket + "__app_secret",
        this.app_secret || ""
      );
      window.sessionStorage.setItem(
        "data_explorer__" + bucket + "__auth_token",
        this.auth_token || ""
      );

      Notifications.show("The credentials has been saved successfully.");

      this.initialize();
    },
    // Removed closeAllPanels
    async getLastAppIdAndSecret() {
      var response_all_apps = await Apps.load(this.project_id);
      if (response_all_apps.status === 200) {
        var response = await Apps.get(response_all_apps.body[(response_all_apps.body.length - 1)].id);
        if (response.status === 200) {
          this.app_id = response.body.app_key;
          this.app_secret = response.body.app_secret;
          this.connect();
        } else {
          Notifications.show("There was a problem while retrieving the last app from the current project id.");
        }
      } else {
        Notifications.show("There was an error while retrieving the apps from the current project.");
      }
    },
    exportData() {
      var data = "";
      this.header.forEach(function(column) {
        data += column.text + ",";
      });
      data += "\n";

      this.data_datatable.forEach(function(row) {
        data += row.id + ",";
        for (var prop in row) {
          if (prop === "id") {
            continue;
          }
          data += row[prop] + ",";
        }
        data += "\n";
      });

      var encoded_data = btoa(data);

      var a = document.createElement("a"); //Create <a>
      a.href = "data:text/csv;base64," + encoded_data; //Image Base64 Goes here
      a.download = this.container + ".csv"; //File name Here
      a.click();
    },
    editRow(row) {
      this.d_edit_data = true;

      this.edit_data["id"] = row.id;
      
      this.columns.forEach(function(column) {
        this.edit_data[column] = row[column];
      }.bind(this));
    },
    deleteData() {
      this.d_delete_data = true;
      this.delete_data.id = this.edit_data.id;
    },
    enterLoad(e) {
      if (e.keyCode == 13) {
        this.load();
      }
    },
    enterAddData(e) {
      if (e.keyCode == 13) {
        this.addData();
      }
    },
    enterEditData(e) {
      if (e.keyCode == 13) {
        this.editData();
      }
    },
    updateFilters(filters) {
      this.filters = filters;
    },
    async load() {
      this.l_load = true;

      var bucket = this.$route.params.id;

      if (this.app_id === "" || this.app_secret === "") {
        Notifications.show("Please define an app id and secret.");
      } else if (
        bucket == undefined ||
        this.container == undefined ||
        this.container == ""
      ) {
        Notifications.show("Please define at least a container.");
      } else {
        this.storage.setBucket(bucket);
        this.storage.setDataset(this.dataset);

        var columns = await Columns.load(this.container.split("|")[0]);
        this.columns = [];
        if (columns.body) {
          columns.body.forEach(
            function(column) {
              this.columns.push(column.name);
            }.bind(this)
          );
        } else {
          Notifications.show(columns.response);
        }
        
        var response;
        var t_start = this.start !== "" ? parseInt(this.start) : undefined;
        var t_limit = this.limit !== "" ? parseInt(this.limit) : undefined;

        if (this.filters.length === 0) {
          response = await this.storage.getAll(this.container.split("|")[1], undefined, t_start, t_limit);
        } else {
          response = await this.storage.get(this.container.split("|")[1], this.filters, undefined, t_start, t_limit);
        }

        if (response.status_code === 200 && response.data) {
          this.data = response.data;
        } else if (
          response.status_code === 200 &&
          response.data === undefined
        ) {
          Notifications.show("The container with this dataset is empty.");
          this.data = [];
        } else {
          Notifications.show(response.message);
        }
      }

      this.l_load = false;
    },
    async loadContainers() {
      var bucket = this.$route.params.id;
      var response = await Containers.load(bucket);

      if (response.status === 200) {
        var available_containers = response.body;
        available_containers.forEach(function(container, index) {
          available_containers[index].id = container.id + "|" + container.name;
        });

        this.available_containers = available_containers;
      }
    },
    addDataPrepare() {
      // Clear all the fields
      this.columns.forEach(
        function(column) {
          this.add_data[column] = "";
        }.bind(this)
      );

      this.d_add_data = true;
    },
    async addData() {
      this.l_add = true;

      var data_object = {};

      this.columns.forEach(
        function(column) {
          data_object[column] = this.add_data[column] || "";
        }.bind(this)
      );

      var response = await this.storage.insert(
        this.container.split("|")[1],
        data_object
      );
      if (response.status_code === 200) {
        Notifications.show("The data has been added.");

        this.columns.forEach(
          function(column) {
            this.add_data[column] = "";
          }.bind(this)
        );

        this.d_add_data = false;
        this.load();
      } else {
        Notifications.show(response.message);
      }

      this.l_add = false;
    },
    duplicateData() {
      this.d_add_data = true;

      // Copy the data from the edit panel to the add panel
      this.columns.forEach(
        function(column) {
          this.add_data[column] = this.edit_data[column];
        }.bind(this)
      );

      this.d_edit_data = false;
      this.d_delete_data = false;
      this.d_add_data = true;
    },
    async deleteDataConfirm() {
      this.l_delete = true;

      var response = await this.storage.delete(this.container.split("|")[1], this.delete_data.id);

      if (response.status_code === 200) {
        Notifications.show("The row has been deleted.");

        this.d_delete_data = false;
        this.d_edit_data = false;

        this.load();
      } else {
        Notifications.show(response.message);
      }

      this.l_delete = false;
    },
    async editData() {
      this.l_edit = true;

      var data = {};
      this.columns.forEach(function (column) {
        data[column] = this.edit_data[column];
      }.bind(this));

      var response = await this.storage.update(this.container.split("|")[1], this.edit_data["id"], data);

      if (response.status_code === 200) {
        Notifications.show("The row has been updated.");

        this.load();
        this.d_edit_data = false;
      } else {
        Notifications.show(response.message);
      }

      this.l_edit = false;
    },
    back() {
      this.$router.go(-1);
    },
    async loginUser() {
      if (this.app_id === "" || this.app_secret === "") {
        Notifications.show("Please define an app id and secret first.");
        return;
      }

      this.l_login = true;
      try {
        var response = await axios.put(
          Vars.API_ENDPOINT + "/client_api/v1/auth/emailpassword.php",
          {
            email: this.login_data.email,
            password: this.login_data.password,
            otp_code: this.login_data.otp
          },
          {
            headers: {
              appid: this.app_id,
              appsecret: this.app_secret
            }
          }
        );

        if (response.data.status === 200) {
          this.auth_token = response.data.body.session_token;
          window.sessionStorage.setItem("data_explorer__" + this.$route.params.id + "__auth_token", this.auth_token);
          Notifications.show("Successfully authenticated. Token retrieved.");
          this.connect();
          this.d_login = false;
          // Clear password after successful login
          this.login_data.password = "";
          this.login_data.otp = "";
        } else {
          Notifications.show(response.data.message);
        }
      } catch (e) {
        if (e.response && e.response.data && e.response.data.message) {
          Notifications.show(e.response.data.message);
        } else {
          Notifications.show("An error occurred during authentication.");
        }
      }
      this.l_login = false;
    }
  },
  components: {
    FilterContainer
  }
};
</script>

<style>
</style>